import { supabase } from './supabase'

/**
 * Adissoo'nun kendi giderleri (supabase/gelir-gider.sql). Yalnız sistem
 * yöneticisi. Gelir abonelik ödemelerinden geliyor (services/subscriptions).
 */
export type ExpenseKind = 'once' | 'monthly'

export interface Expense {
  id: string
  title: string
  category: string
  amountKurus: number
  kind: ExpenseKind
  /** Tek seferlikte gider günü; aylıkta başladığı gün (o ay sayılır). */
  spentOn: string
  /** Aylıkta bittiği gün (o ay sayılmaz); boşsa sürüyor. */
  endsOn: string | null
  note: string
}

function db() {
  if (!supabase) throw new Error('Supabase yapılandırılmamış')
  return supabase
}

export async function listExpenses(): Promise<Expense[]> {
  const { data, error } = await db()
    .from('expenses')
    .select('id, title, category, amount_kurus, kind, spent_on, ends_on, note')
    .order('spent_on', { ascending: false })
  if (error) throw new Error(error.message)
  return (data ?? []).map((r) => ({
    id: r.id,
    title: r.title,
    category: r.category ?? '',
    amountKurus: Number(r.amount_kurus),
    kind: r.kind,
    spentOn: r.spent_on,
    endsOn: r.ends_on ?? null,
    note: r.note ?? '',
  }))
}

export async function saveExpense(e: Omit<Expense, 'id'> & { id?: string }): Promise<void> {
  const row = {
    title: e.title,
    category: e.category,
    amount_kurus: e.amountKurus,
    kind: e.kind,
    spent_on: e.spentOn,
    ends_on: e.kind === 'monthly' ? e.endsOn : null,
    note: e.note,
  }
  const { error } = e.id
    ? await db().from('expenses').update(row).eq('id', e.id)
    : await db().from('expenses').insert(row)
  if (error) throw new Error(error.message)
}

export async function deleteExpense(id: string): Promise<void> {
  const { error } = await db().from('expenses').delete().eq('id', id)
  if (error) throw new Error(error.message)
}
